// todo: move js/designer-flux/utils/ClientUtils to packages/systems/core/utils/ClientUtils & deprecate this file

import {curry, flattenDeep} from 'lodash';
import {FileRecordType} from '@packages/systems/core/records/FileRecord';

const safeGetWindow = (fallback: {
  ['.alert']: never;
  ['.document']: never;
  ['.location']: never;
}) => (typeof window === 'undefined' ? fallback : window);

// @ts-expect-error - TS2345 - Argument of type '{}' is not assignable to parameter of type '{ ".alert": never; ".document": never; ".location": never; }'.
const safeWindow = safeGetWindow({});
// @ts-expect-error - TS2339 - Property 'document' does not exist on type '(Window & typeof globalThis) | { ".alert": never; ".document": never; ".location": never; }'.
const {document} = safeWindow;

const getDefaultHeaders = () => {
  const csrfToken = document
    .querySelector('meta[name=_csrf]')
    .getAttribute('content');

  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
    'X-XSRF-Token': String(csrfToken),
  };
};

// @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
const cleanSlashes = (url) => {
  // Prevent `endpoint/?` redirect issue with cors
  url = url.replace('/?', '?');
  // Replace multiple slashes with single slashes
  return url.replace(/([^:])\/\/+/g, '$1/');
};

const makeQuery = (o: any) => {
  return flattenDeep(
    Object.keys(o)
      .filter((k) => o[k] !== undefined)
      .map((k) => makeQueryPart(k, o[k]))
  ).join('&');
};

// @ts-expect-error - TS7022 - 'makeQueryPart' implicitly has type 'any' because it does not have a type annotation and is referenced directly or indirectly in its own initializer. | TS7024 - Function implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions. | TS7006 - Parameter 'k' implicitly has an 'any' type. | TS7006 - Parameter 'v' implicitly has an 'any' type.
const makeQueryPart = curry((k, v) => {
  return Array.isArray(v)
    ? v.map(makeQueryPart(k + '[]'))
    : [k, v].map(encodeURIComponent).join('=');
});

// @ts-expect-error - TS7023 - 'makePath' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions. | TS7006 - Parameter 'p' implicitly has an 'any' type.
const makePath = (p) => {
  if (typeof p === 'string') return p;
  if (Array.isArray(p))
    return p
      .filter((s) => Boolean(s))
      .map(makePath)
      .join('/');
  return '?' + makeQuery(p);
};

const refreshIfLoggedOut = (r: any) => {
  return r.code === 401 || r.code === 403
    ? refreshPage(r.msg)
    : Promise.reject(r);
};

const refreshPage = (msg: any) => {
  // @ts-expect-error - TS2339 - Property 'alert' does not exist on type '(Window & typeof globalThis) | { ".alert": never; ".document": never; ".location": never; }'.
  safeWindow.alert(msg || "You've been logged out. Sign back in to continue.");
  // @ts-expect-error - TS2339 - Property 'location' does not exist on type '(Window & typeof globalThis) | { ".alert": never; ".document": never; ".location": never; }'.
  safeWindow.location.reload();
};

const handleJSON = (r: any) => {
  return r.json().then(rejectFetchErrors(r)).catch(refreshIfLoggedOut);
};

const rejectFetchErrors = (r: any) => {
  return (json: any) => (r.ok ? json : Promise.reject(json));
};

let config = {
  host: '',
  mode: 'no-cors',
  credentials: 'same-origin',
  publicFetch: false,
};

export const configure = (options: Record<any, any>) => {
  config = {...config, ...options};
};

const request = (
  // @ts-expect-error - TS7006 - Parameter 'path' implicitly has an 'any' type.
  path,
  // @ts-expect-error - TS2739 - Type '{}' is missing the following properties from type '{ body: string; method: "POST"; }': body, method
  {
    // @ts-expect-error - TS2339 - Property 'headers' does not exist on type '{ body: string; method: "POST"; }'.
    headers = {},
    ...rest
  }: {
    body: string;
    method: 'POST';
  } = {}
) => {
  const {host, credentials} = config;

  const options = {
    headers: {
      ...getDefaultHeaders(),
      ...headers,
    },
    credentials,
    ...rest,
  } as const;

  if (host) path = flattenDeep([host, path]);
  path = cleanSlashes(makePath(path));

  // @ts-expect-error - TS2345 - Argument of type '{ readonly body: string; readonly method: "POST"; readonly headers: any; readonly credentials: string; }' is not assignable to parameter of type 'RequestInit'.
  return fetch(path, options).then(handleJSON);
};

const getS3FileName = (file: any) =>
  decodeURIComponent(file.s3Url.split('/').slice(-1)[0]);

type ElasticTranscoderResponse = {
  use_media_convert: false;
  poll_url: string;
  video_urls: Array<string>;
  poster_image_url: string;
  file: FileRecordType;
};

type MediaConvertResponse = {
  use_media_convert: true;
  job_id: string;
  video_urls: Array<string>;
  poster_image_url: string;
  file: FileRecordType;
};

export type ScheduledTranscode =
  | ElasticTranscoderResponse
  | MediaConvertResponse;

export const scheduleTranscode = (
  file: FileRecordType
): Promise<ScheduledTranscode> => {
  return request(['/api/sites', file.siteId, 'transcode'], {
    method: 'POST',
    body: JSON.stringify({file: getS3FileName(file)}),
  }).then((job) => ({...job, file: file.set('transcodeProgress', 0)}));
};
